<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-11 00:49 -->
<!-- Description:  -->
<template>
  <form @submit.prevent="save">
    <div class="mb-3">
      <label for="">Nombre</label>
      <input class="form-control" type="text" v-model="reg.name">
    </div>
    <div class="mb-3">
      <label for="">SLUG</label>
      <input class="form-control" type="text" v-model="reg.slug">
    </div>
    <button :disabled="sending" type="submit"
      class="btn btn-primary mb-3">Guardar</button>
    <div class="alert alert-success mb-3" v-show="saved">
      Guardado Correctamente
    </div>
    <div class="alert alert-danger mb-3" v-show="hasError">
      Ocurrio algun problema 
    </div>
  </form>
</template>
<script>
import AdminService from "../AdminService.js";

const rules = {}
export default {
  name: "PermissionForm",
  components: {
    //
  },

  // directives

  props: {
    disabled: { default: false },
    content: {
      default: () => ({}),
    }
  },

  data: () => ({
    sending: false,
    saved: false,
    hasError: false,
    reg: {}
  }),

  computed: {
    errors() { return false; }
  },

  // watch: {},

  mounted() {
    if(this.content.id) {
      this.reg = this.content;
    }
  },

  methods: {
    async save() {
      this.sending = true;
      this.saved = false;
      this.hasError = false;
      try {
        let res = await AdminService.savePermission(this.reg);
        this.saved = true;
        this.$emit("saved", res);
      } catch (e) {
        this.hasError = true;
      }
      this.sending = false;
    },
    reset() { this.sending =false; },
    setValue() {},
  }
};
</script>
<style scoped></style>

